<ds-promo-badge tone="sun" iconSrc="/assets/icons/savings.svg" iconAlt="savings" [label]="label" />
